import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { MODERN_COLORS, MODERN_RADIUS } from './tokens';

const STATUS_MAP = {
  success: {
    bg: MODERN_COLORS.successBg,
    text: MODERN_COLORS.successText,
    border: MODERN_COLORS.successBorder,
  },
  warning: {
    bg: MODERN_COLORS.warningBg,
    text: MODERN_COLORS.warningText,
    border: MODERN_COLORS.warningBorder,
  },
  error: {
    bg: MODERN_COLORS.errorBg,
    text: MODERN_COLORS.errorText,
    border: MODERN_COLORS.errorBorder,
  },
  info: {
    bg: MODERN_COLORS.infoBg,
    text: MODERN_COLORS.infoText,
    border: MODERN_COLORS.infoBorder,
  },
  default: {
    bg: '#f8fafc',
    text: '#64748b',
    border: '#e2e8f0',
  },
};

export const ModernStatusBadge = ({
  label,
  status = 'default',
  icon,
  sx = {},
}) => {
  const config = STATUS_MAP[status] || STATUS_MAP.default;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: 1.25,
        py: 0.35,
        borderRadius: MODERN_RADIUS.pill,
        bgcolor: config.bg,
        color: config.text,
        border: `1px solid ${config.border}`,
        fontSize: '0.72rem',
        fontWeight: 700,
        letterSpacing: '0.02em',
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {icon}
      {label}
    </Box>
  );
};

ModernStatusBadge.propTypes = {
  label: PropTypes.node.isRequired,
  status: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'default']),
  icon: PropTypes.node,
  sx: PropTypes.object,
};

export default ModernStatusBadge;
